import * as React from 'react';

import classnames from 'classnames';

import {BusinessPill} from 'shells/acorn-pill/svg/business';
import {EnterprisePill} from 'shells/acorn-pill/svg/enterprise';
import {FoundationPill} from 'shells/acorn-pill/svg/foundation';
import {ProPill} from 'shells/acorn-pill/svg/pro';

import styles from './trial-limits-table.module.css';

export function HeaderRow() {
    return (
        <div className={styles['header-row']}>
            <div className={styles.cell}></div>
            <div className={classnames(styles.cell, styles.text)}>You</div>
            <div className={styles.cell}>
                <FoundationPill />
            </div>
            <div className={styles.cell}>
                <ProPill />
            </div>
            <div className={styles.cell}>
                <BusinessPill />
            </div>
            <div className={styles.cell}>
                <EnterprisePill />
            </div>
        </div>
    );
}
